import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/ProductCarousel.css";
import { useNavigate } from "react-router-dom";

// import Product1 from "../assets/images/New-Products/hydew-body-lotion.jpg";
import Product2 from "../assets/images/New-Products/Hydew-moisturiser.jpg";
// import Product3 from "../assets/images/New-Products/Angel-dew.jpg";
import Product4 from "../assets/images/New-Products/BiouvFluidspf50.jpg";
import Product5 from "../assets/images/New-Products/Biouv-mineral.jpg";
import Product6 from "../assets/images/New-Products/hYDEW-PM.jpg";
import Product7 from "../assets/images/New-Products/Bio-uv-Sprey.jpg";
import Product8 from "../assets/images/New-Products/Niaa-serum.jpg";
import Product9 from "../assets/images/New-Products/Cutam.jpg";
import Product10 from "../assets/images/New-Products/Biouv-32.jpg";
import Product11 from "../assets/images/New-Products/biouv50.jpg";
import Product12 from "../assets/images/New-Products/new/sebosal-FaceWash.jpeg";

const ProductCarousel = () => {
  const navigate = useNavigate();
  const [itemsPerSlide, setItemsPerSlide] = useState(4);

  const products = [
    // { img: Product1, title: "Hydew Body Lotion", sub: "RESTORE, HYDRATE & REJUVENATE", route: "/product/SkinCare/hydewbodylotion", area: "Body · 150 ml" },

    // { img: Product3, title: "Angel Dew", sub: "EMBRACE WITH GENTLE CARE", route: "/product/SkinCare/angeldew", area: "Body · 100 ml" },

    { img: Product10, title: "BioUV 32+", sub: "ULTIMATE PROTECTION", route: "/product/SkinCare/BioUV32", area: "Face · 50 gm" },
    { img: Product11, title: "BioUV 50+", sub: "SHIELD, BLUR & GLOW", route: "/product/SkinCare/BioUV50", area: "Face · 50 gm" },
    { img: Product7, title: "BioUV Spray", sub: "SPRAY SUNSCREEN FROM HEAD TO TOE", route: "/product/SkinCare/BioUV50Spray", area: "Face, Body, Hair · 100 ml" },
    { img: Product4, title: "BioUV Fluid", sub: "INVISIBLE SHIELD FOR YOUR SKIN", route: "/product/SkinCare/BioUVFluid", area: "Face · 50 gm" },
    { img: Product5, title: "BioUV Mineral", sub: "PURE MINERAL DEFENSE FOR EVERYDAY SUN", route: "/product/SkinCare/BioUVMineral", area: "Face · 50 gm" },
    { img: Product12, title: "Sebosal FaceWash", sub: "FIGHT ACNE, WITHOUT DRYNESS", route: "/product/SkinCare/Sebosal", area: "Face · 150 ml" },
    { img: Product8, title: "Niaa Serum", sub: "WITH ADVANTAGES OF BIOPROMELA", route: "/product/SkinCare/niaa-serum", area: "Face · 30 ml" },
    { img: Product6, title: "Hydew PM", sub: "REJUVENATE WITH NEUROCOSMETIC", route: "/product/SkinCare/HYDewPM", area: "Face · 80 gm" },
    { img: Product2, title: "Hydew Face Moisturiser", sub: "REPAIR, REGENERATE & RESTORE", route: "/product/SkinCare/Hydew-Face", area: "Face · 50 ml" },
    { img: Product9, title: "Cutam Palm and Sole", sub: "INNOVATIVE UREA REPAIR", route: "/product/SkinCare/cutam", area: "Palm and Sole · 100 gm" },
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) setItemsPerSlide(1);
      else if (window.innerWidth <= 1200) setItemsPerSlide(2);
      else setItemsPerSlide(4);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const chunkedProducts = [];
  for (let i = 0; i < products.length; i += itemsPerSlide) {
    chunkedProducts.push(products.slice(i, i + itemsPerSlide));
  }

  return (
    <section className="carousel-section">
      <h2 className="carousel-heading">
        What’s New In{" "}
        <span className="winter-slide-text">Our Summer Basket</span>
      </h2>

      <div id="productCarousel" className="carousel slide">
        <div className="carousel-inner">
          {chunkedProducts.map((group, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <div className="carousel-row">
                {group.map((product, i) => (
                  <div className="product-card" key={i}>
                    <div className="product-media">
                      <img src={product.img} alt={product.title} />
                      <div className="product-overlay">
                        <p className="overlay-title">Application Area & Quantity</p>
                        <p className="overlay-sub">{product.area}</p>
                        <button
                          className="view-btn"
                          onClick={() => navigate(product.route)}
                        >
                          View Product
                        </button>
                      </div>
                    </div>
                    <div className="card-footer-brief">
                      <p className="brief-title">{product.title}</p>
                      <p className="brief-sub">{product.sub}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <button className="carousel-control-prev" type="button" data-bs-target="#productCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon"></span>
        </button>

        <button className="carousel-control-next" type="button" data-bs-target="#productCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>
    </section>
  );
};

export default ProductCarousel;